import { render } from "./ChangeLang.vue?vue&type=template&id=037f1754&scoped=true&ts=true"
import script from "./ChangeLang.vue?vue&type=script&lang=ts"
export * from "./ChangeLang.vue?vue&type=script&lang=ts"

import "./ChangeLang.vue?vue&type=style&index=0&id=037f1754&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037f1754"]])

export default __exports__